export default __webpack_public_path__ + "static/LanguageProficiency-bb927729673069b2744e8f6f609d0ecd.png";